import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailNote } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailNote";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { DetailSectionHeader } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailSectionHeader";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";
import { hasAnyDetailValue } from "web_myplann/Shared/Utils/hasAnyDetailValue";

const PageResources = Resources.PortfolioDetail;

type Props = {
	purchaseDate?: string | null;
	description?: string | null;
	yearOfCompletion?: number | null;
	lastValuationDate?: string | null;
};

export const PropertyPurchaseDetails: FC<Props> = ({
	purchaseDate,
	description,
	yearOfCompletion,
	lastValuationDate,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	const hasDetails = hasAnyDetailValue(
		purchaseDate,
		yearOfCompletion,
		lastValuationDate,
		description,
	);

	if (!hasDetails) {
		return null;
	}

	return (
		<>
			<DetailSectionHeader
				title={t(Resources.DataCard.BasicInfo.additionalInfo)}
			/>
			<Stack bgcolor={theme.palette.background.paper}>
				<DetailRow
					label={t(PageResources.Property.PurchaseDate)}
					value={dateFormatter(purchaseDate)}
				/>
				<DetailRow
					label={t(PageResources.Property.YearOfCompletion)}
					value={yearOfCompletion}
				/>
				<DetailRow
					label={t(PageResources.Property.LastValuation)}
					value={dateFormatter(lastValuationDate)}
				/>
				<DetailNote
					label={t(PageResources.Property.AdditionalDescription)}
					text={description ?? ""}
				/>
			</Stack>
		</>
	);
};
